"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montegiordano": {
    "4b351b38": [{
      "hkey": "b1eb5ab5",
      "slug": "montegiordano",
      "name": "Montegiordano",
      "primary": true,
      "skipSearch": false
    }],
    "farinella": [{
      "hkey": "b1eb5ab5",
      "slug": "montegiordano",
      "name": "Montegiordano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "709a79d1": [{
      "hkey": "b1eb5ab5",
      "slug": "montegiordano",
      "name": "Montegiordano",
      "primary": true,
      "skipSearch": false
    }],
    "mandrone": [{
      "hkey": "b1eb5ab5",
      "slug": "montegiordano",
      "name": "Montegiordano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc4de47c": [{
      "hkey": "b1eb5ab5",
      "slug": "montegiordano",
      "name": "Montegiordano",
      "primary": true,
      "skipSearch": false
    }],
    "secolare": [{
      "hkey": "b1eb5ab5",
      "slug": "montegiordano",
      "name": "Montegiordano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;